import config from '@/config/config';

import Index from '@/pages/config/system-user/index.vue';
import List from '@/pages/config/system-user/list/list.vue';
import View from '@/pages/config/system-user/view/view.vue';
import New from '@/pages/config/system-user/new/new.vue';
import Edit from '@/pages/config/system-user/edit/edit.vue';

const modulePermission = config.modules.systemUser;

export default {
  path: '/system-user',
  name: 'system-user',
  component: Index,
  meta: {
    requiresAuth: true,
    modulePermission: modulePermission,
    requiresPermission: 'enabled_read',
  },
  children: [
    {
      path: 'list',
      name: 'system-user-list',
      component: List,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: 'enabled_read',
      },
    },
    {
      path: ':id',
      name: 'system-user-view',
      component: View,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: 'enabled_read',
      },
      props: true,
    },
    {
      path: 'new',
      name: 'system-user-new',
      component: New,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: 'enabled_create',
      },
    },
    {
      path: ':id/e',
      name: 'system-user-edit',
      component: Edit,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: 'enabled_edit',
      },
      props: true,
    },
  ],
};
